import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { environment } from './environments/environment';
import { installTauriFetch, isTauri } from './app/core/tauri/tauri-http';

declare global {
  interface Window {
    __env: any;
    __version: any;
  }
}

// Conservé pour rétro-compat (le vrai isTauri vit dans tauri-http).
export { isTauri };

async function bootstrap() {
  // Route les requêtes distantes via le client HTTP Rust (bypass CORS).
  // No-op hors Tauri, le build web classique n'est pas impacté.
  await installTauriFetch();

  const [config, version] = await Promise.all([
    fetch(environment.configFile).then((response) => response.json()),
    fetch('assets/version.json')
      .then((response) => response.json())
      .catch(() => ({ version: 'dev', environment: 'local' })),
  ]);

  window.__env = config;
  window.__version = version;

  await bootstrapApplication(AppComponent, appConfig);
}

bootstrap().catch((err) =>
  console.error('Erreur de chargement des fichiers de configuration', err),
);
